module.exports = __webpack_public_path__ + "img/po-bg-bottom.bd270c16.png";